<ng-template conversationalChatMessage></ng-template>
